<template>
  <div>
    <div class="content">
      <span v-if="false">
        <span class="idClass">ID:</span>
        <span class="userNameClass">{{ reply.userName }}</span>
      </span>
      <span class="replyContentClass">
        <span
          v-if="showAllSubReplyContent || reply.content.length < 3 * 67"
          @click="showAllSubReplyContent = false"
        >
          {{ reply.content }}
        </span>
        <span v-else @click="showAllSubReplyContent = true">
          {{ reply.content.substring(0, 3 * 67 - 6) }}...
        </span>
      </span>
      <span class="contentAppendInfoClass">
        <el-button
          icon="el-icon-chat-dot-round"
          circle
          @click="
            showAllThreeSubPosts(reply.replyId, reply.content, reply.userName)
          "
        ></el-button>
        <span class="userNameClass">{{ reply.userName }}</span>
        <span class="contentAppendInfoDateTimeClass">{{
          new Date(reply.addDate).toLocaleString()
        }}</span>
        <deleteSubReplyCom
          style="display: inline-block;"
          :userOwnTheReply="reply.userOwnTheReply"
          :replyId="reply.replyId"
          v-on:flushDateEvent="flushFirstPageListFun"
        ></deleteSubReplyCom>
      </span>
    </div>
    <div>
      <el-dialog title="" v-model="dialogVisible" width="60%">
        <div class="dialogParentReplyClass">
          <span class="idClass2">{{ chooseReplyUserName }}</span>
          <span class="replyContentClass2">{{ chooseReplyContent }}</span>
          <span class="contentAppendInfoClass2">{{
            new Date(reply.addDate).toLocaleString()
          }}</span>
        </div>
        <hr />
        <subReplyToSubReplyCom
          :replyId="chooseReplyId"
          class="adminReplysWindowClass"
        ></subReplyToSubReplyCom>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import deleteSubReplyCom from '../subDelete/subPostDelete.vue'
import subReplyToSubReplyCom from '../adminReplys/adminReplyList.vue'
export default {
  props: {
    reply: Object,
    index: Number
  },
  data () {
    return {
      showAllSubReplyContent: false,
      dialogVisible: false,
      chooseReplyId: 0,
      chooseReplyContent: '',
      chooseReplyUserName: ''
    }
  },
  methods: {
    showAllThreeSubPosts (replyId, replyContent, replyUserName) {
      this.chooseReplyId = replyId
      this.chooseReplyContent = replyContent
      this.chooseReplyUserName = replyUserName
      this.dialogVisible = true
    },
    flushFirstPageListFun () {
      this.$emit('flushNowPostListEvent')
    }
  },
  components: {
    deleteSubReplyCom,
    subReplyToSubReplyCom
  }
}
</script>

<style scoped>
.content {
  width: 100%;
  background-color: white;
  color: black;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-radius: 0.3rem;
  border-bottom: 0.03rem solid black;
  font-size: 1rem;

  display: flex;
  flex-direction: row;
  justify-content: baseline;
  align-items: flex-start;

  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.idClass {
  margin-left: 2rem;
}
.userNameClass {
  width: 130px;
}
.replyContentClass {
  width: 100%;
}
.adminReplysWindowClass {
  margin-left: 14%;
}
.contentAppendInfoClass {
  margin-bottom: -1rem;
  font-size: 0.6rem;
  align-self: flex-end;
  margin-left: auto;
  margin-right: 1rem;
  width: 20%;
  text-align: right;
}
.dialogParentReplyClass {
  display: flex;
  flex-direction: row;
  justify-content: baseline;
  align-items: flex-start;
  font-weight: bold;
  font-size: 1rem;
}
.idClass2 {
  display: inline-block;
  width: 14%;
}
.replyContentClass2 {
  display: inline-block;
  width: 60%;
  letter-spacing: 1px;
}
.contentAppendInfoClass2 {
  display: inline-block;
  width: 23%;
  align-self: flex-end;
  text-align: right;
}
.contentAppendInfoDateTimeClass {
  display: inline-block;
}
</style>
